import React from "react";
import { Box, Stack, Typography, IconButton } from "@mui/material";
import Iconify from "../iconify";

export const SFM_AMBER = "#F88F1D";
export const SFM_SLATE = "#1D2330";

// soft, rounded input styling to match the SFM-branded Figma dialog
export const FIELD_SX = {
  "& .MuiOutlinedInput-root": { borderRadius: "9px", backgroundColor: "#F6F8FA" },
  "& .MuiOutlinedInput-notchedOutline": { borderColor: "#DFE4EA" },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#C3CAD3" },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: SFM_AMBER },
  "& .MuiInputLabel-root": { fontSize: 13 },
  "& .MuiInputLabel-root.Mui-focused": { color: SFM_SLATE },
};

export function BrandedDialogHeader({ title, subtitle, code, onClose }) {
  return (
    <Box sx={{ bgcolor: SFM_SLATE, px: 3, py: 2, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <Stack direction="row" spacing={1.5} alignItems="center" sx={{ minWidth: 0 }}>
        <Box sx={{ width: 40, height: 40, borderRadius: "11px", bgcolor: SFM_AMBER, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
          <Typography sx={{ color: SFM_SLATE, fontWeight: 800, fontSize: 13 }}>SFM</Typography>
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography noWrap sx={{ color: "#fff", fontWeight: 700, fontSize: 17, lineHeight: 1.25 }}>{title}</Typography>
          {subtitle && <Typography noWrap sx={{ color: "#C7CCD6", fontSize: 11.5 }}>{subtitle}</Typography>}
        </Box>
      </Stack>
      <Stack direction="row" spacing={1.5} alignItems="center" sx={{ flexShrink: 0 }}>
        {code && <Box sx={{ bgcolor: SFM_AMBER, color: SFM_SLATE, fontWeight: 700, fontSize: 11, px: 1.4, py: 0.5, borderRadius: "20px", whiteSpace: "nowrap" }}>{code}</Box>}
        {onClose && <IconButton onClick={onClose} size="small" sx={{ color: "#C7CCD6" }}><Iconify icon="eva:close-fill" /></IconButton>}
      </Stack>
    </Box>
  );
}

export function SectionHeader({ children }) {
  return (
    <Stack direction="row" spacing={1.25} alignItems="center" sx={{ mt: 1.5, mb: 0.5 }}>
      <Box sx={{ width: 3, height: 15, borderRadius: 1, bgcolor: SFM_AMBER }} />
      <Typography sx={{ fontWeight: 800, fontSize: 12, letterSpacing: 0.6, textTransform: "uppercase", color: SFM_SLATE }}>{children}</Typography>
    </Stack>
  );
}
